import { v4 as uuidv4 } from 'uuid'
import Iframe from './Iframe'

export default class Handler {
  constructor (key, tokenCallback, hostedPageCallback) {
    this.key = key
    this.uuid = uuidv4()

    this.iframe = new Iframe(this.uuid)

    this.iframe.on('token', (event) => {
      tokenCallback(event.data)
    })

    this.iframe.on('hostedPageRedirect', (event) => {
      hostedPageCallback(event.data)
    })

    this.iframe.render()
  }

  open (options) {
    options.key = this.key
    this.iframe.open(options)
  }
}



// WEBPACK FOOTER //
// ./src/api/components/multipay/Handler.js